import { GXO_TRACKING_CUTOFF_DATE } from "~/assets/constants/ecomApi";

export const timeNowInSeconds = (): number => Date.now() / 1000;
export const timeNowIn = (): number => Date.now();

const formatDate =
    (format: Intl.DateTimeFormatOptions) => (date: string, locale: string) =>
        Intl.DateTimeFormat(locale, format).format(new Date(date));

export const publishDate = formatDate({
    month: "short",
    day: "numeric",
    year: "numeric",
});

export const lastCatalogueRequestDate = formatDate({
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
});

export const timestampToISO = (val: string): string => {
    return new Date(val).toISOString();
};

export function enableNewGxoTracking(currentOrderDate: string) {
    const currentOrderTime = new Date(timestampToISO(currentOrderDate)).getTime();
    const gxoCutOffTime = new Date(timestampToISO(GXO_TRACKING_CUTOFF_DATE)).getTime();
    return currentOrderTime >= gxoCutOffTime;
}